import YandexShare from "react-yandex-share";
import { FacebookShareButton } from "react-share";
import { useTranslation } from "react-i18next";
import { FacebookIcon } from "../utils/svg";
import i18n from "i18next";

const PostShare = ({ currentLanguage, post, socials }) => {
  const { t } = useTranslation();
  let locale = i18n.language;

  let services = socials.toString();

  return (
    <div className="post__share">
      <div className="post__share-label" data-key="ui.share">
        {t("ui.share")}
      </div>
      <div className="post__share-buttons socials socials_share">
        <YandexShare content={{ description: post.attributes.title, image: post.attributes.photo.cover }} theme={{ lang: currentLanguage, services: services }} />
        {locale !== "ru" && (
          <FacebookShareButton url={window.location.href} className="post__share-button">
            <FacebookIcon />
          </FacebookShareButton>
        )}
      </div>
    </div>
  );
};

export default PostShare;
